(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/hooks/use-task.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/hooks/use-task.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _React = React,
  useCallback = _React.useCallback,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useReducer = _React.useReducer;
function reducer(state) {
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case 'TASK_EXECUTE':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'pending'
      });
    case 'TASK_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'resolved',
        result: action.result
      });
    case 'TASK_FAILURE':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'rejected',
        error: action.error
      });
    case 'TASK_CANCEL':
      return {
        status: 'idle',
        result: null,
        error: null
      };
    default:
      throw new Error('Unknown action!');
  }
}
const initialState = {
  status: 'idle',
  result: null,
  error: null
};
function useTask() {
  const _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    task = _useState2[0],
    setTask = _useState2[1];
  useEffect(() => {
    if (!task) {
      return;
    }
    dispatch({
      type: 'TASK_EXECUTE'
    });
    task.then(result => {
      if (!task.cancelled) {
        dispatch({
          type: 'TASK_SUCCESS',
          result
        });
      }
    }).catch(error => {
      if (!task.cancelled) {
        dispatch({
          type: 'TASK_FAILURE',
          error
        });
      }
    });
    return () => {
      var _task$cancel;
      (_task$cancel = task.cancel) === null || _task$cancel === void 0 || _task$cancel.call(task);
      task.cancelled = true;
    };
  }, [task]);
  const cancel = () => {
    setTask(null);
    dispatch({
      type: 'TASK_CANCEL'
    });
  };
  const run = useCallback(t => {
    setTask(t);
    return t;
  }, []);
  return _objectSpread(_objectSpread({}, state), {}, {
    run,
    cancel
  });
}
svs.ticket_partner.sharedComponents.hooks.useTask = useTask;

 })(window);